export let loginConfig={
    crmAppId:"wx8938b27f4eee36eb",
    scrmAppId:"wx481a0fab5241298b",
    crmHost:"crm.86122m.com",
    scrmHost:"scrm.86122m.com"
}
